import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Manifesto({ t }) {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE }}
              className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-amberburn"
            >
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" />
              {t.manifesto.eyebrow}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
              className="font-serif text-2xl font-normal leading-tight text-forest sm:text-3xl lg:text-4xl"
            >
              {t.manifesto.title}
            </motion.h2>
          </div>
        </div>

        <div className="lg:col-span-8">
          {t.manifesto.chapters.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid grid-cols-[auto_1fr] gap-6 border-t border-creamborder py-10 transition-colors duration-500 first:border-t-0 first:pt-0 hover:bg-creamdark/40 sm:gap-12 sm:px-4"
            >
              <span className="font-mono text-sm tracking-[0.2em] text-gold transition-transform duration-500 group-hover:-translate-y-1">
                {c.num}
              </span>
              <div>
                <h3 className="font-serif text-xl font-medium text-forest transition-colors duration-300 group-hover:text-forestlight sm:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-sand sm:text-base">
                  {c.text}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
